export const PresetTypes = {
  SEARCH: 'search',
  FILTERS: 'filters',
} as const;
